var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('Banner',{attrs:{"title":"ABOUT US","subtitle":"關於六協","img":_vm.bannerImg}}),_c('div',{staticClass:"container"},[_c('Spirit'),_c('Features'),_c('Process'),_c('Prospect'),_c('Products')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }